import type { IConfig } from "byzantine";

export const config: IConfig = {
  network: {
    cache: {
      ttlMilliseconds: 5 * 1000,
    },
    useMocks: process.env.NODE_ENV === "development",
    recordingEnabled: false,
  },
};
